let blackList = [
  '89.102.174.228'
]

export default {
  namespaced: true,
  state: {
    geo: {
      list: [],
      summary: {},
      summaryFinal: {},
      totalNodeCount: 0,
      commNodePercent: 0,
      teamNodes: 114,
    }
  },

  mutations: {
    upateGeoList(state, geoList) {
      state.geo.list = geoList.data.Payload.filter(item=> !~blackList.indexOf(item.IPAddress))
    },

    updateSummary(state, geoSummary) {
      let newSummary = geoSummary.data.Payload.summary
      state.geo.totalNodeCount = geoSummary.data.Payload.totalCount
      state.geo.commNodePercent = Math.floor((1 - 114 / state.geo.totalNodeCount) * 100)

      newSummary = newSummary.sort((a,b) => {return a.Count-b.Count})
      state.geo.summaryFinal = newSummary
      // if(Object.keys(newSummary).length !== Object.keys(state.geo.summaryFinal).length) {
      //   newSummary = newSummary.sort((a,b) => {return a.Count-b.Count})
      //   state.geo.summaryFinal = newSummary
      // } else {
      //   console.log(state.geo.summaryFinal)
      //   console.log(Object.keys(newSummary).length, '  ', Object.keys(state.geo.summaryFinal).length)
      // }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/map.js